export default __webpack_public_path__ + "static/media/spinnerLight.d69a2e1b.gif";